import { Shark, Utils, View } from "shark-mvc";
import $ from "jquery";

import templateContent from "Templates/views/quotation-edit.html";

import clientListView from "../../views/contacts-and-leads/clientListView";
import mainNavComponent from "Components/mainNavComponent";
import { quotationItemModal } from "../components/quotationItemModalComponent";

class QuotationEditView extends View {
	constructor () {
		super("quotationEditView");
		this.setTemplate(templateContent);
	}







	
	addQuotationItemBtn_clickHandler () {
		$("#quotationItemModal").modal("show");
	}

	backToClientListBtn_clickHandler () {
		Shark.openPage(clientListView);
	}

	beforeLoad () {
		fetch("/data/quotationParts.json")
		.then(response => response.json())
		.then(data => quotationEditView.parseQuotationData(data));

		console.log(Shark.get("currQuotation"))
		this.set({
			currQuotation: Shark.get("currQuotation")
		});
		Shark.render();
	}

	beforeRender () {
		this.set({
			quotationType: Shark.get("quotationType")
		});
		Shark.render();
	}

	init () {
		this.addComponents([mainNavComponent, quotationItemModal]);
	}

	// parseQuotationData (data) {
	// 	console.log(data);

	// 	const resins = Utils.safp(data, "type", "resins");
	// 	// const resinList = Shark.getInstanceList("QuotationResin", resins.items);

	// 	Shark.set("resinList", resinList);

	// 	this.set({
	// 		resins: resinList
	// 	});

	// 	this.render();
	// }

	// resinsChk_changeHandler (event) {
	// 	const $t = $(event.target);

	// 	if ($t.prop("checked")) {
	// 		$t.closest(".row").next().show();
	// 	}
	// 	else {
	// 		$t.closest(".row").next().hide();
	// 	}
	// }
}

const quotationEditView = new QuotationEditView();

Shark.registerView(quotationEditView);

export { quotationEditView };
